<template>
  <div class="container member-withdraw-list">
    <div class="common-header-wrap">
      <mt-header title="提现明细" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="pb-30" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
    <div
      class="list-wrapper"
      v-if="withdraw_list && withdraw_list.length"

    >
      <div
        class="container"
        v-for="(item, index) in withdraw_list"
        :key="item.pdc_id"
      >
        <div class="top-wrapper">
          <div class="left-wrapper">
            <label class="status">{{
              item.pdc_payment_state_text
              }}</label>
            <label class="title">{{ item.pdc_bank_user }}：{{ item.pdc_bank_no }}</label>
          </div>
          <div class="right-wrapper">
            <label class="price">￥{{ item.pdc_amount }}</label>
            <label class="subtitle">提现金额</label>
          </div>
          <div class="top-line"></div>
        </div>
        <div class="center-wrapper">
          <label class="desc">申请时间：{{ item.pdc_addtime_text }}</label>
        </div>

      </div>
    </div>
    <empty-record v-else-if="withdraw_list && !withdraw_list.length"></empty-record>
  </div>
  <div class='common-add-btn-wrapper'><div class="div common-btn common-add-btn"  @click="goAdd">新增</div></div>
    <!--身份验证-->
    <mt-popup v-model="sendAuthCode" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="身份验证" class="common-header">
          <mt-button slot="left" icon="back" @click="sendAuthCode=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <common-send-code @checkSuccess="checkSuccess" />
      </div>
    </mt-popup>

    <!--申请提现-->
    <mt-popup v-model="addWithdrawVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="申请提现" class="common-header">
          <mt-button slot="left" icon="back" @click="addWithdrawVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <div class="main-content">
        <flex-line class="field-line menu-item" :show-border="true"><span class="field-name">提现金额</span><div class="field-line-right" slot="right"><input class="field-input" v-model="amount" /></div></flex-line>
        <flex-line class="field-line menu-item" :show-border="true"><span class="field-name">支付密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password" /></div></flex-line>
        <flex-line v-if="bank_length > 0" :show-border="true" :is-link="true" @click.native="memberbankVisible=true"><span>收款银行</span><span slot="right">{{memberbank_name}}</span></flex-line>
        <div class="common-btn ds-button-large" @click="addWithdraw"  v-if="bank_length > 0">提交</div>
        <div class="common-btn ds-button-large" @click="goMemberbacklist"  v-else>请先添加收款账号</div>
        </div>
      </div>
      
    </mt-popup>
    <mt-popup v-model="memberbankVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="收款银行" class="common-header">
          <mt-button slot="left" icon="back" @click="memberbankVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
          <mt-radio
            @change="setMemberBank"
                  v-model="memberbank_id"
                  :options="memberbankOptions">
          </mt-radio>
      </div>
      </mt-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getWithdrawList, addWithdraw } from '../../../api/memberWithdraw'
import { getBankList } from '../../../api/memberBank'
import { Toast, Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import CommonSendCode from '../common/CommonSendCode'
import flexLine from '../../flexLine'
export default {
  name: 'BalanceHistory',
  components:{
    flexLine,
    EmptyRecord,
    CommonSendCode
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      bank_length:0,
      amount: '',
      memberbankList:{},
      memberbankOptions: [],
      memberbank_name:'',
      memberbank_id: '',
      password: '',
      addWithdrawVisible: false,
      memberbankVisible: false,
      sendAuthCode: false,
      wrapperHeight: 0,
      withdraw_list: false
    }
  },
  created () {
    getBankList().then(res => {
      let temp = res.result.bank_list
      this.bank_length = temp.length
      for (var i in temp) {
        let item = temp[i]
        if(item.memberbank_type=='alipay'){
        item.memberbank_name='支付宝'
        }else if(item.memberbank_type=='weixin'){
        item.memberbank_name='微信'
        }
        this.memberbankList[item.memberbank_id]=item.memberbank_name+item.memberbank_no
        this.memberbankOptions.push({
          label: item.memberbank_name+item.memberbank_no,
          value: item.memberbank_id
        })
      }
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  mounted () {
    this.wrapperHeight = document.documentElement.clientHeight - 90
  },
  methods: {
    setMemberBank(e){
    this.memberbank_name=this.memberbankList[e]
    this.memberbankVisible=false
    },
    addWithdraw () {
      addWithdraw(this.amount, this.memberbank_id, this.password).then(res => {
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    checkSuccess () {
      this.addWithdrawVisible = true
    },
    goAdd () {
      if (!this.user.member_mobilebind && !this.user.member_emailbind) {
        Toast('请先绑定手机或邮箱')
        this.$router.push({ name: 'MemberSetting' })
      } else {
        this.sendAuthCode = true
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    goMemberbacklist(){
         this.$router.push({ name: 'MemberBankList' })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getWithdrawList(true)
      }
    },
    getWithdrawList () {
      Indicator.open()

      getWithdrawList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let temp = res.result.list
        if (temp) {
          if (!this.withdraw_list) {
            this.withdraw_list = temp
          } else {
            this.withdraw_list = this.withdraw_list.concat(temp)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
.main-content{background: #fff;padding:0 $pageSpace}
.container {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

}
.header {
  border-bottom: 1px solid #e8eaed;
}
.list-wrapper {
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff;
  }
  .top-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
  }
  .left-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }
  .right-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }
  .status {
    font-size:$subFontSize;
    color: #5296db;
    margin-left:0.75rem;
    margin-top:0.65rem;
  }
  .title {
    font-size:$fontSize;
    color: #666666;
    margin-left:0.75rem;
    margin-top:0.25rem;
    margin-right:0.5rem;
    margin-bottom:0.2rem;
  }
  .price {
    font-size:$h1;
    color:$primaryColor;
    margin-right:0.75rem;
    margin-top:0.5rem;
    text-align: right;
  }
  .subtitle {
    font-size:$fontSize;
    color: #999999;
    margin-right:0.75rem;
    margin-top:0.25rem;
    margin-bottom:0.5rem;
    text-align: right;
  }
  .top-line {
    position: absolute;
    left:0.75rem;
    bottom: 0;
    right: 0;
    height: 1px;
    background-color: #e8eaed;
  }
  .desc {
    color: #999999;
    font-size:$fontSize;
    margin-left:0.75rem;
    margin-top:0.25rem;
  }
  .center-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    border-bottom: 1px solid #e8eaed;
    padding-bottom:0.25rem;
  }
}

</style>
